import * as React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

interface Props {
  className?: string;
}

const BackButton: React.FC<Props> = ({ className }) => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <Button
      type="button"
      onClick={handleBack}
      variant="new_outline"
      size="sm"
      className={cn(className)}
    >
      <ArrowLeft />
      Back
    </Button>
  );
};

export default BackButton;
